exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".typePickerContainer-ebfa08fd{background:white;max-width:480px;padding:12px;box-shadow:0 2px 4px 0 rgba(0,0,0,0.2)}.icon-d3378e1b{transition:all .2s ease-in-out;width:34px;height:40px}.icon-d3378e1b:hover{transform:scale(1.2)}\n", ""]);

// Exports
exports.locals = {
	"typePickerContainer": "typePickerContainer-ebfa08fd",
	"icon": "icon-d3378e1b"
};